import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import '../Marcas/Marcas.css'; // Reusing Marcas styles
import Swal from 'sweetalert2';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import EmpresaForm from "../Components/EmpresaForm/EmpresaForm";
import { useAuth } from "../Context/auth";

function NovaEmpresa() {
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();

    // Verifica permissão de cadastro
    React.useEffect(() => {
        if (appUserData && !appUserData['cadastrar_empresas']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para cadastrar empresas.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleCadastrarEmpresa(formData) {
        setMensagem('');
        if (!formData.nome) {
            setMensagem('Nome/Razão Social é obrigatório.');
            return;
        }
        setLoading(true);

        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/empresas`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao cadastrar empresa.");
            }
            navigate('/app/empresas');
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/empresas')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Nova <span className="highlight">Empresa</span>
                        </h1>
                    </div>
                </div>

                <main className="marcas-content" style={{ maxWidth: '98%' }}>
                    {mensagem && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}
                    <EmpresaForm onSubmit={handleCadastrarEmpresa} loading={loading} />
                </main>
            </div>
        </div>
    );
}
export default NovaEmpresa;